//  console.log(window.innerWidth);
 let scrollSet = 'content';
 if(window.innerWidth <= 425){
    scrollSet = 'content';
 }

const fuseSettingsConfig = {
    layout          : {
        style : 'layout1',
        config: {
            scroll : scrollSet,
            navbar : {
                
                display : true,
                folded  : false,
                position: 'left'
            },
            toolbar: {
                display : true,
                style   : 'fixed',
                // style   : 'static',
                position: 'below'
            },
            footer : {
                display : false,
                style   : 'fixed',
                position: 'below'
            },
            leftSidePanel : {
                display : true,
            },
            rightSidePanel : {
                display : true,
            },
            mode   : 'fullwidth'
        }
    },
    customScrollbars: true,
    theme           : {
        main   : 'light6',
        navbar : 'mainThemeDark',
        toolbar: 'mainThemeLight',
        footer : 'mainThemeDark'
    }
};

export default fuseSettingsConfig;


// WEBPACK FOOTER //
// ./src/fuse-configs/fuseSettingsConfig.js